import { uploadFile } from './upload';
import { downloadFile } from './download';

export default { uploadFile, downloadFile };
